import React, { useState, useEffect } from "react";
import { StyledPaper } from "../StyledMui";
import { Grid, Typography, Box, Paper, Avatar, Table, TableBody, TableCell,  TableHead, TableRow,  } from "@mui/material";
import { StyledBox, StyledTypo, } from "../StyledMui";
import { CheckCircle, Error, ChatBubble, Email } from "@mui/icons-material";
import Chart from "react-apexcharts";
import useStore from "../Store";
import Cards from "./Cards";

function HoverDetail(props) {
  const { journeyId, interactionId, logs, getLogs } = useStore((state) => state.header)
  const { getTemplate } = useStore((state) => state.mapper)
  
  const [ optionLabel, setOptionLabel] = useState({
    thisSuccess: '발송성공',
    thisFail: '발송오류',
    thisKakao: '카카오톡',
    thisSms: 'MMS문자'
  })
  const [ countLogs, setCountLogs] = useState({
    thisCount: 0,
    thisSuccess: 0,
    thisFail: 0,
    thisKakao: 0,
    thisSms: 0
  })
  const [ options, setOptions] = useState({
    colors: ['#388e3c', '#d32f2f'],
    chart: {
        
        type: "donut",
        height: 200,
        width: 'auto'
      },
      series: [],
      labels: [],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {label : '발송현황', show: true}
            }
          }
        }
      }
  })
  const [ detailOptions, setDetailOptions] = useState({
    colors: ['#F7E600','#008ffb'],
    chart: {
        
        type: "donut",
        height: 200,
        width: 'auto'
      },
      series: [],
      labels: [],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {label : '발송종류', show: true},
            }
          }
        }
      }
  })

  useEffect(() => {
    //setVariabledContent(variabledContents[page]);
    console.log(journeyId)
    if(journeyId !== '') getLogs()
  }, [journeyId])

  useEffect(() => {
    //setVariabledContent(variabledContents[page]);
    if(logs.length > 0) {
        setLogs()
    }
  }, [logs])

  useEffect(() => {
    setOptions({
        ...options,
        series: Object.keys(countLogs).filter(el => ['thisSuccess','thisFail'].includes(el)).map(el => countLogs[el]),
        labels: Object.keys(countLogs).filter(el => ['thisSuccess','thisFail'].includes(el)).map(el => optionLabel[el])
    })
    setDetailOptions({
        ...detailOptions,
        series: Object.keys(countLogs).filter(el => ['thisKakao','thisSms'].includes(el)).map(el => countLogs[el]),
        labels: Object.keys(countLogs).filter(el => ['thisKakao','thisSms'].includes(el)).map(el => optionLabel[el])
    })
  }, [countLogs])

  const setLogs = () => {
    let tmpId 
    setCountLogs({...countLogs, ...(logs.reduce((a,c) => {
        //console.log(c.versionId, interactionId)
        if(c.versionId === interactionId){
            tmpId = c.templateId
        console.log(c)
            a.thisCount++
            c.resultCode && String(c.resultCode) === '1000' ? a.thisSuccess++ : a.thisFail++
            if(c.sendType){
                c.sendType.toLowerCase() === 'k' ? a.thisKakao++ : a.thisSms++
            }
        }
        return a
    },{
        thisCount: 0,
        thisSuccess: 0,
        thisFail: 0,
        thisKakao: 0,
        thisSms: 0
    }))})
    //console.log('count : ',tmpId)
    if(tmpId) getTemplate(tmpId)
  }

  return (
    <>
        <StyledPaper style={{ height: "100%" }}>
        <Grid container spacing={3}>
        {/* Summary section */}
        <Grid item xs={12} container spacing={2} justifyContent="center">
            <Grid item xs={3}>
            <Paper elevation={3} sx={{ borderRadius: 2 }}>
                <Box display="flex" p={1} justifyContent="space-between">
                <Box>
                    <Typography>발송 성공</Typography>
                    <Typography variant="h4">{countLogs.thisSuccess}</Typography>
                </Box>
                <Box alignSelf="start">
                    <Avatar
                    sx={{
                        bgcolor: "#388E3C",
                        width: 56,
                        height: 56,
                        mb: 1,
                    }}>
                    <CheckCircle fontSize="medium" />
                    </Avatar>
                </Box>
                </Box>
            </Paper>
            </Grid>
            <Grid item xs={3}>
            <Paper elevation={3} sx={{ borderRadius: 2 }}>
                <Box display="flex" p={1} justifyContent="space-between">
                <Box>
                    <Typography>발송 실패</Typography>
                    <Typography variant="h4">{countLogs.thisFail}</Typography>
                </Box>
                <Box alignSelf="start">
                    <Avatar
                    sx={{
                        bgcolor: "#D32F2F",
                        width: 56,
                        height: 56,
                        mb: 1,
                    }}>
                    <Error fontSize="medium" />
                    </Avatar>
                </Box>
                </Box>
            </Paper>
            </Grid>
            <Grid item xs={3}>
            <Paper elevation={3} sx={{ borderRadius: 2 }}>
                <Box display="flex" p={1} justifyContent="space-between">
                <Box>
                    <Typography>카카오발송</Typography>
                    <Typography variant="h4">{countLogs.thisKakao}</Typography>
                </Box>
                <Box alignSelf="start">
                    <Avatar
                    sx={{
                        bgcolor: "#F7E600",
                        width: 56,
                        height: 56,
                        mb: 1,
                    }}>
                    <ChatBubble fontSize="medium" />
                    </Avatar>
                </Box>
                </Box>
            </Paper>
            </Grid>
            <Grid item xs={3}>
            <Paper elevation={3} sx={{ borderRadius: 2 }}>
                <Box display="flex" p={1} justifyContent="space-between">
                <Box>
                    <Typography>문자메세지 발송</Typography>
                    <Typography variant="h4">{countLogs.thisSms}</Typography>
                </Box>
                <Box alignSelf="start">
                    <Avatar
                    sx={{
                        bgcolor: "#008ffb",
                        width: 56,
                        height: 56,
                        mb: 1,
                    }}>
                    <Email fontSize="medium" />
                    </Avatar>
                </Box>
                </Box>
            </Paper>
            </Grid>
        </Grid>

        {/* Chart section */}
        <Grid item xs={6}>
            <Box  sx={{
        width: 'auto',
        height: 300,}}>
            <Chart options={options} series={options.series} type="donut"  height="300"/>
            </Box>
        </Grid>
        <Grid item xs={6}>
            <Box  sx={{
        width: 'auto',
        height: 300,}}>
            <Chart options={detailOptions} series={detailOptions.series} type="donut"  height="300"/>
            </Box>
        </Grid>

        <Grid item xs={12}>
            <StyledBox component="div">
                <StyledTypo>발송 템플릿</StyledTypo>
            </StyledBox>
        </Grid>

        <Grid item xs={12} container spacing={2} justifyContent="center">
            <StyledPaper style={{ height: "100%" }}>
                <Cards/>
            </StyledPaper>
        </Grid>

        <Grid item xs={12} >
            <StyledBox component="div">
                <StyledTypo>상세내역</StyledTypo>
            </StyledBox>
        </Grid>
        <Grid item xs={12}>
            <Table size="large">
                    <TableHead>
                        <TableRow>
                            <TableCell>Customer Key</TableCell>
                            <TableCell>요청일시</TableCell>
                            <TableCell>요청결과</TableCell>
                            <TableCell>발송결과</TableCell>
                            <TableCell>발송종류</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            logs.filter(el => el.versionId === interactionId).map(el => {
                               return( <>
                                    <TableRow>
                                        <TableCell  item xs={false} sm={5}>
                                            <Box display="flex" justifyContent="center" width="100%">
                                            <Typography variant="body1">{ el.recipientCode }</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell  item xs={false} sm={5}>
                                            <Box display="flex" justifyContent="center" width="100%">
                                            <Typography variant="body1">{ el.created }</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell  item xs={false} sm={5}>
                                            <Box display="flex" justifyContent="center" width="100%">
                                            <Typography variant="body1">{ el.responseCode }</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell  item xs={false} sm={5}>
                                            <Box display="flex" justifyContent="center" width="100%">
                                            <Typography variant="body1">{ el.resultCode }</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell  item xs={false} sm={5}>
                                            <Box display="flex" justifyContent="center" width="100%">
                                            <Typography variant="body1">{ el.sendType }</Typography>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                </>)
                            })
                        }
                    </TableBody>
                </Table>
        </Grid>
        </Grid>
        </StyledPaper>
    </>
  );
}

export default HoverDetail;
